import React, { useState, useEffect } from "react";
import { stacksApi } from "../../lib/constants";
import './style.scss';

import Default from "./Default";
import Basic from "./Basic";
import Advanced from "./Advanced";
import axios from "axios";
// import { isEmptyObject } from "jquery";
import { getNftOwnerPublically } from "../../services/chime";

const altOrigin = window.location.origin;
const NFTAvatar = ({ authorPrincipal, authorName, userSettings }) => {
    const [avatarType, setAvatarType] = useState("default");
    const [basicData, setBasicData] = useState(null);
    const [advancedData, setAdvancedData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    async function initAvatar() {
        try {
            if (authorName) {
                const nameUrl = `${userSettings?.stacksApi || stacksApi}/v1/names/${authorName}/zonefile`;
                const { data: { zonefile } } = await axios.get(nameUrl);
                const profileUrl = new RegExp(/https:\/\/(.*)json/).exec(zonefile)[0];
                const profileJson = await axios.get(profileUrl);
                const storageUrl = profileJson.data[0].decodedToken.payload.claim.apps[altOrigin];
                const { data } = await axios.get(storageUrl + 'loadout.json')
                const { type, basic, advanced } = data;
                console.log('Look here', data);
                // Set basicData and advancedData only if the avatarType is 'basic' or 'advanced'
                if (type === "basic") {
                    const nftOwnerPrincipal = await getNftOwnerPublically({ contract: basic.contract, id: basic.id });
                    if (authorPrincipal !== nftOwnerPrincipal) {
                        setAvatarType('default')
                        return
                    }
                    setAvatarType(type)
                    setBasicData(basic);
                } else if (type === 'advanced') {
                    const nftOwnerPrincipal = await getNftOwnerPublically({ contract: advanced.contract, id: advanced.id })
                    if (authorPrincipal !== nftOwnerPrincipal) {
                        setAvatarType('default');
                        return;
                    }
                    setAvatarType(type)
                    setAdvancedData(advanced);
                }
            } else {
                setError("Error: No authorName found");
            }
        } catch (error) {

            setError("Error occurred while fetching data");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        // Call the fetchLoadout function
        initAvatar();
    });

    useEffect(() => {
    }, [avatarType, error])

    // Render appropriate avatar based on avatarType
    return (
        <>
            {avatarType === 'default' && <Default authorPrincipal={authorPrincipal} />}
            {avatarType === 'basic' && basicData && < Basic basic={basicData} authorPrincipal={authorPrincipal} />}
            {avatarType === 'advanced' && advancedData !== null && <Advanced advanced={advancedData} authorPrincipal={authorPrincipal} />}
            {loading && <div className="spinner"></div>}
        </>

    )
};

export default NFTAvatar;
